import axios from 'axios';

// 创建 Axios 实例
const service = axios.create({
    // baseURL: 'http://192.168.1.124:9090/', // 替换为你的 API 基础 URL
    baseURL:'https://hg.xiangban365.com/nursing_admin',
    timeout: 5000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 可以在这里添加请求头，例如添加 token
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }   
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        console.log('err' + error);
        return Promise.reject(error);
    }
);

export default service;    